module.exports = __webpack_public_path__ + "img/ww1.4f60d86d.jpg";